export const SELECT_UNIVERSE = 'UNIVERSE/SELECT';
export const CLEAR_UNIVERSE = 'UNIVERSE/CLEAR';
export const ADD_UNIVERSE = 'UNIVERSE/ADD';
export const DELETE_UNIVERSE = 'UNIVERSE/DELETE';
export const UPDATE_UNIVERSE = 'UNIVERSE/UPDATE';
